
// Core data model interfaces for account-product-geo mapping

export interface Account {
  id: string;
  name: string;
  country: string;
  region: string;
  industry: string;
  channel?: string;
}

export interface Product {
  id: string;
  name: string;
  productLine: string;
  category: string;
}

export interface Geography {
  country: string;
  region: string;
  salesArea: string;
}

export interface SalesTransaction {
  invoiceId: string;
  date: string;
  accountId: string;
  productId: string;
  quantity: number;
  revenue: number;
  shipToCountry: string;
  attributionType?: 'Direct' | 'Channel' | 'Estimated' | 'Allocated';
  allocationMethod?: string;
}

export interface SalesRepMapping {
  salesRepId: string;
  accountId: string;
  region: string;
}

// Enums for standardization
export enum AllocationBasis {
  SHIP_TO_VOLUME = 'shipToVolume',
  REVENUE = 'revenue',
  SALES_TEAM = 'salesTeam',
  SELL_THROUGH = 'sellThrough',
  MARKET_SIZE = 'marketSize',
  LIST_PRICE = 'listPrice',
  MARGIN_CONTRIBUTION = 'marginContribution',
  PROPORTIONAL = 'proportional',
  WRITE_OFF = 'writeOff'
}

export enum AttributionDimension {
  GEOGRAPHY = 'geography',
  ACCOUNT = 'account',
  PRODUCT = 'product',
  TIME_PERIOD = 'timePeriod'
}
